import React from "react";
import { IconSearch } from "../../../icons";

export default function DocsPreviewPanel({
  children,
  title = null,
  label = "VORSCHAU",
  icon: Icon = IconSearch,
  className = "",
}) {
  const classes = ["ds-docs-preview-panel", className].filter(Boolean).join(" ");

  return (
    <div className={classes}>
      <div className="ds-docs-preview-panel__label">
        {Icon ? <Icon sx={{ fontSize: 16 }} aria-hidden="true" /> : null}
        <span>{label}</span>
        {title ? <span className="ds-docs-preview-panel__title">{title}</span> : null}
      </div>
      {children}
    </div>
  );
}
